import React, { useEffect, useState } from 'react';
import { FlatList, ActivityIndicator } from 'react-native';
import { ItemOrderApi } from '../api';
import type { ItemOrderProps, ItemProps } from '../../types';
import ItemOrderCard from './ItemOrderCard';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';
import Pagination from '../../Components/Pagination';

type OrderManagerProps = {
    onClose: () => void
}
const order_sections = [ 'header', 'orders' ]
const OrderManager = ({ onClose }:OrderManagerProps) => {
    const Colors = useColors();

    const [ loading, setLoading ] = useState(false);
    const [ data, setData ] = useState<{
        offset: number,
        items:ItemProps[],
        item_orders:ItemOrderProps[]
    }>({
        offset:0,
        items:[],
        item_orders:[]
    })

    const { item_orders, offset } = data;

    useEffect(() => {
        getDataFromServer(0)
    },[])

    const getDataFromServer = async(offset:number) => {
        setLoading(true);
        const my_orders = await ItemOrderApi.getMyItemOrders(offset);
        setData({
            items:my_orders.items,
            item_orders: my_orders.item_orders,
            offset
        })
        setLoading(false)
    }

    const renderItemOrders = (data: { item:ItemOrderProps, index:number }) => {
        return (
            <ItemOrderCard
                item_order={data.item}
            />
        )
    }

    const renderSections = (data: {item:string, index:number}) => {
        switch(data.item){
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                        <View transparent style={{flex:1}}>
                            <Text size={20} theme='h1'>MY ORDER HISTORY</Text>
                            <Text style={{ marginTop:5}} theme='description'>Review your order history below.  Select an item to see the transaction details.</Text>
                        </View>
                    </View>
                )
            case 'orders':
                return (
                    <View>
                        {loading ?
                        <ActivityIndicator size='large' color={Colors.text.h1} />
                        :<></>}
                        <FlatList
                            data={item_orders}
                            renderItem={renderItemOrders}
                            keyExtractor={(item) => item.item_order_id.toString()}
                        />
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
            <View style={{ flex:1 }}>
                <FlatList
                    data={order_sections}
                    key={`order_history_sections`}
                    keyExtractor={(item) => item}
                    renderItem={renderSections}
                />
            </View>
            <Pagination
                onNext={() => getDataFromServer(offset + 1)}
                onPrevious={() => getDataFromServer(offset - 1)}
                offset={offset}
            />
            <View type='footer' style={{ flexDirection:'row', padding:20 }}>
                <Button
                    title='BACK'
                    type='close'
                    style={{ flex:1 }}
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default OrderManager